import type { IconData } from '@stacksjs/iconify-core'

export const select: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 275h232L116 391zm232-92H0L116 67z\"/>",
  "width": 240,
  "height": 700,
  "viewBox": "0 0 240 700"
}

export default select
